import { useContractRead, useNetwork } from 'wagmi';
import { getDexContracts } from '@/config/dex-v3-config';
import { pancakeswapV3FactoryABI } from '@/config/abis/pancakeswapV3Factory';

/**
 * Hook to check if a PancakeSwap V3 pool exists for a token pair and fee tier
 */
export function usePoolExists(
  token0: string | undefined,
  token1: string | undefined,
  feeTier: number
) {
  const { chain } = useNetwork();
  const contracts = chain?.id ? getDexContracts(chain.id) : null;

  // Sort tokens to ensure correct order (token0 < token1)
  const sortedTokens = token0 && token1 && token0.toLowerCase() < token1.toLowerCase()
    ? [token0, token1]
    : [token1, token0];

  const { data: poolAddress, isLoading, isError, refetch } = useContractRead({
    address: contracts?.factory as `0x${string}`,
    abi: pancakeswapV3FactoryABI,
    functionName: 'getPool',
    args: sortedTokens[0] && sortedTokens[1] 
      ? [sortedTokens[0] as `0x${string}`, sortedTokens[1] as `0x${string}`, feeTier]
      : undefined,
    enabled: Boolean(contracts?.factory && sortedTokens[0] && sortedTokens[1]),
    watch: false,
  });

  // Pool exists if address is not zero address
  const exists = poolAddress && poolAddress !== '0x0000000000000000000000000000000000000000';

  return {
    exists,
    poolAddress: poolAddress as string | undefined,
    isLoading,
    isError,
    refetch,
    sortedTokens,
  };
}
